export default {
  computed: {
    featureFlagEnabled: function() {
      return function(name) {
        return _.get(window, `heb.data.features.${name}`, false);
      }
    },
  }
}